import basicEmptyCheck from './basicEmptyCheck';
import isEmpty from './isEmpty';
function checkRequired(value, trim, emptyAllowed) {
    // String trim
    if (trim && typeof value === 'string') {
        value = value.replace(/(^\s*)|(\s*$)/g, '');
    }
    if (emptyAllowed) {
        return !basicEmptyCheck(value);
    }
    // Array
    if (Array.isArray(value)) {
        return !!value.length;
    }
    return !isEmpty(value);
}
export default checkRequired;
//# sourceMappingURL=checkRequired.js.map